import toast from 'react-hot-toast'

interface OAuthErrorMessages {
  accessDenied: string
  generic: string
}

const DEFAULT_MESSAGES: OAuthErrorMessages = {
  accessDenied: 'Access was denied. Please grant consent to sign in.',
  generic: 'Authentication failed. Please try again.',
}

/**
 * Handles OAuth errors and displays appropriate user-friendly messages
 * @param error - The error code from OAuth (e.g., 'access_denied')
 * @param errorDescription - Optional description of the error
 * @param messages - Custom error messages for different scenarios (optional, uses defaults if not provided)
 */
export function handleOAuthError(
  error: string,
  errorDescription: string | null,
  messages?: Partial<OAuthErrorMessages>
): void {
  console.log('OAuth error:', error, errorDescription)

  const errorMessages = { ...DEFAULT_MESSAGES, ...messages }

  // Show user-friendly error message
  error === 'access_denied'
    ? toast.error(errorMessages.accessDenied)
    : toast.error(errorDescription || errorMessages.generic)
}
